import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'
import moment from 'moment'
import {nonCashValidate} from "../../../../validation/scheme/nonCash";
const prolongSchema = (date, isExtendWithDaysLimit) => {
    const dateHeaderValidation = Joi.date()
        .iso()
        .error(errorsResolver({
            dateFormat: `Некорректная дата`,
        }));

    if (isExtendWithDaysLimit) {
        dateHeaderValidation.less(moment(date).add(61, 'days').valueOf())
            .error(errorsResolver({
                dateLess: `Не позже 60 дней`
            }));
    }

    return Joi.object({
        dateHeader: dateHeaderValidation,
        deals: Joi.array().items(
            Joi.object({
                dealId: Joi.number(),
                extensionDate: Joi.date()
                    .iso()
                    .error(errorsResolver({
                        dateFormat: `Некорректная дата`,
                    })),
                sum: Joi.string()
                    .allow('')
                    .max(9)
                    .error(errorsResolver({
                        max: `Не более девяти знаков`
                    })),
                penaltiesNumbers: Joi.array().items(Joi.boolean()).optional()
            })
        ),
        deposit: nonCashValidate,
        introduced: Joi.string()
            .allow('')
            .max(9)
            .error(errorsResolver({
                max: `Не более девяти знаков`
            })),
    })
}
export default prolongSchema
